/* Faceted-filter progressive enhancement.
   Baseline (no JS): the filter form is a plain GET form, chips are links,
   sorting reloads the page — everything works.
   With JS: filter changes re-render the collection section via the Section
   Rendering API, update the URL with pushState, and support the browser
   back button. Focus and scroll position are preserved sensibly. */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root || !('fetch' in window)) return;

  var sectionId = root.getAttribute('data-section-id');
  var debounceTimer = null;

  function setBusy(busy) {
    var results = document.querySelector('[data-collection-results]');
    if (results) {
      results.setAttribute('aria-busy', String(busy));
      results.classList.toggle('is-loading', busy);
    }
  }

  function currentFormParams() {
    var form = document.querySelector('[data-filter-form]');
    var params = new URLSearchParams(form ? new FormData(form) : undefined);
    // keep current sort
    var pageParams = new URLSearchParams(window.location.search);
    var sort = pageParams.get('sort_by');
    if (sort) params.set('sort_by', sort);
    // drop empty price inputs so URLs stay clean/shareable
    var toDelete = [];
    params.forEach(function (value, key) { if (value === '') toDelete.push(key); });
    toDelete.forEach(function (key) { params.delete(key); });
    return params;
  }

  function renderFromUrl(url, push) {
    setBusy(true);
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    fetch(u.toString())
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-root]');
        if (!fresh) throw new Error('section render missing root');
        // Preserve open/closed state of filter groups
        var openLabels = [];
        root.querySelectorAll('.filter-group[open] > summary span').forEach(function (s) {
          openLabels.push(s.textContent.trim().replace(/\s+\d+$/, ''));
        });
        root.innerHTML = fresh.innerHTML;
        root.querySelectorAll('.filter-group').forEach(function (group) {
          var label = group.querySelector('summary span');
          if (!label) return;
          var name = label.textContent.trim().replace(/\s+\d+$/, '');
          if (openLabels.length && openLabels.indexOf(name) === -1) group.removeAttribute('open');
          else if (openLabels.indexOf(name) !== -1) group.setAttribute('open', '');
        });
        if (push) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({ facets: true }, '', clean.toString());
        }
        setBusy(false);
        bind(); // re-bind listeners on the fresh DOM
        document.dispatchEvent(new CustomEvent('wiley:collection-rendered'));
      })
      .catch(function () {
        // graceful fallback: full navigation
        window.location.href = url;
      });
  }

  function applyFilters() {
    var params = currentFormParams();
    var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    renderFromUrl(url, true);
  }

  // Accordion behaviour: opening one filter group closes any other open one.
  function bindFilterAccordion() {
    document.querySelectorAll('.filter-group').forEach(function (group) {
      if (group.dataset.accordionBound) return;
      group.dataset.accordionBound = '1';
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        document.querySelectorAll('.filter-group').forEach(function (other) {
          if (other !== group) other.open = false;
        });
      });
    });
  }

  function bind() {
    var form = document.querySelector('[data-filter-form]');
    if (form && !form.dataset.facetsBound) {
      form.dataset.facetsBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
        // close the mobile drawer if open
        var drawer = document.querySelector('[data-filter-drawer]');
        var overlay = document.querySelector('[data-filter-overlay]');
        if (drawer) drawer.classList.remove('is-open');
        if (overlay) overlay.hidden = true;
        document.body.style.overflow = '';
      });
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-facet-input]')) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFilters, 350);
      });
    }

    document.querySelectorAll('[data-facet-chip]').forEach(function (chip) {
      if (chip.dataset.facetsBound) return;
      chip.dataset.facetsBound = '1';
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        renderFromUrl(chip.getAttribute('href'), true);
      });
    });

    var loadMore = document.querySelector('[data-load-more]');
    if (loadMore && !loadMore.dataset.facetsBound) {
      loadMore.dataset.facetsBound = '1';
      loadMore.addEventListener('click', function (e) {
        e.preventDefault();
        var strings = window.wileyStrings || {};
        loadMore.textContent = strings.loading || 'Loading…';
        var u = new URL(loadMore.href, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-collection-results] .record-grid');
            var grid = document.querySelector('[data-collection-results] .record-grid');
            if (newGrid && grid) {
              while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
            }
            var newButton = doc.querySelector('[data-load-more]');
            if (newButton) {
              loadMore.href = newButton.href;
              loadMore.textContent = newButton.textContent.trim();
              delete loadMore.dataset.facetsBound;
              bind();
            } else {
              loadMore.parentElement.remove();
            }
            // keep a crawlable/back-able URL
            var clean = new URL(u.toString());
            clean.searchParams.delete('section_id');
            history.replaceState(null, '', clean.toString());
          })
          .catch(function () { window.location.href = loadMore.href; });
      });
    }

    bindFilterAccordion();
  }

  window.addEventListener('popstate', function () {
    renderFromUrl(window.location.href, false);
  });

  bind();
})();
